import { useQuery } from '@tanstack/react-query';

import { Payment } from '@/types/payment';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

const METHOD = 'GET';
const ENDPOINT = 'payments/stripe-history';

export type UseGetStripePaymentHistoryParams = {
  tenant_id?: string;
  unit_id?: string;
};

export const QUERY_KEY = (params?: UseGetStripePaymentHistoryParams) =>
  getQueryKey(METHOD, ENDPOINT, params);

export type ApiResponse_GetStripePaymentHistory = Payment[];

/**
 * Hook to fetch payment history directly from Stripe API, including pending transactions
 */
export const useGetStripePaymentHistory = (
  params?: UseGetStripePaymentHistoryParams,
  enabled = true
) => {
  const { session } = useAuth();

  return useQuery({
    queryKey: QUERY_KEY(params),
    enabled: enabled && !!session?.access_token,
    queryFn: async () => {
      const data = await handleApiCall<
        ApiResponse_GetStripePaymentHistory,
        UseGetStripePaymentHistoryParams
      >(session, METHOD, getResolvedEndpoint(ENDPOINT, {}), params);
      return data;
    },
  });
};
